exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-panel .ant-tabs-bar {\n  background: #f0f2f5;\n  margin-bottom: 0;\n}\n.ant-tabs-nav-wrap {\n  padding: 0 30px;\n}\n.ant-form-horizontal .ant-form-item-label {\n  line-height: normal;\n  margin-bottom: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/pages/AuthPage/authPage.less
// module id = 1330
// module chunks = 0